import React, { useState } from 'react';
import Update from '../Update';
import Media from '../Media';

import { alpha, useTheme } from '@mui/material';
import { Card, Stack, Fade, Divider, Checkbox, Typography, CardHeader, CardActionArea, Chip } from '@mui/material';
import { AvatarPopover, NewSpeedDial, CardHeaderTitle } from 'components';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';

import { FormattedMessage } from 'react-intl';

export default function Model({ model, delay, direction, checked, handleSelect, selectOnClick, refetch, color }) {
  const {
    language: { direction: dir },
  } = useSelector((state) => state.setting);
  const isRtl = dir === 'rtl';
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);

  const getUserFullName = (model) => {
    if (model?.manager?.firstname && model?.manager?.lastname) {
      return `${model?.manager?.firstname} ${model?.manager?.lastname}`;
    }
    if (model?.manager?.firstname) {
      return `${model?.manager?.firstname}`;
    }
    if (model?.lastname) {
      return `${model?.manager?.lastname}`;
    } else {
      return undefined;
    }
  };

  const chips = [
    { id: '1', name: 'siteType', title: model?.type?.title },
    { id: '2', name: 'siteManager', title: getUserFullName(model) },
  ];

  const siteTitel = model?.title;

  const [updateOpen, setUpdateOpen] = useState(false);
  const canUpdate = isAuthenticated && hasRequiredRole(['superadmin', 'siteManager', 'companyCeo'], userInfo?.roles);
  const handleRowClick = () => (canUpdate && !selectOnClick ? setUpdateOpen(true) : handleSelect());

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 100, enter: delay * 120, exit: delay * 140 }}>
        <Card
          sx={{
            position: 'relative',
            // bgcolor: checked && 'action.disabledBackground',
            bgcolor: checked ? 'primary.light' : color ? 'action.disabledOpacity' : 'action.focus',
          }}
        >
          <Stack
            left={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            alignItems="center"
            position="absolute"
            justifyContent="flex-start"
            direction={isRtl ? 'row' : 'row-reverse'}
          >
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
            <Media id={model.id} model="Site" collection="images" title={model.title} subheader={''}>
              <AvatarPopover media={model?.media[0]?.full_url} />
            </Media>
          </Stack>
          <Stack
            right={8}
            zIndex={1}
            columnGap={0.5}
            height="100%"
            direction="row"
            alignItems="center"
            position="absolute"
            justifyContent="flex-end"
          >
            <NewSpeedDial>
              {isAuthenticated && hasRequiredRole(['superadmin', 'siteManager', 'companyCeo'], userInfo?.roles) && (
                <Update ids={model.id} title={<FormattedMessage id="update" />} refetch={refetch} />
              )}
              {/* <Media id={model.id} model="Site" collection="banner" /> */}
            </NewSpeedDial>
          </Stack>
          <CardActionArea onClick={handleRowClick}>
            <CardHeader
              sx={{ px: 0.5, pl: 13 }}
              title={<CardHeaderTitle title={siteTitel} chips={chips} />}
              // subheader={
              //   <Typography fontSize={12} variant="subtitle2">
              //     {model?.type?.title}
              //   </Typography>
              // }
            />
          </CardActionArea>
        </Card>
      </Fade>
      {updateOpen && (
        <Update
          open
          ids={model.id}
          refetch={refetch}
          title={<FormattedMessage id="update" />}
          onClose={() => setUpdateOpen(false)}
        />
      )}
      <Divider variant="middle" />
    </>
  );
}
